import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const getBreadcrumbName = (segment, index, segments) => {
    // Skip showing IDs in the breadcrumb
    if (!isNaN(segment) && (
      segments[index - 1] === 'jobs' || 
      segments[index - 1] === 'customers' ||
      segments[index - 1] === 'estimations' ||
      segments[index - 1] === 'vendors'
    )) {
      return null;
    }
    
    switch (segment) {
      case 'admin':
        return null;
      case 'customers':
        return 'Customers';
      case 'jobs':
        return 'Jobs';
      case 'estimations':
        return 'Estimations';
      case 'vendors':
        return 'Vendors';
      case 'new':
        return 'Create New';
      case 'edit':
        return null;
      default:
        // Check if segment is a number
        if (!isNaN(parseInt(segment))) {
          return 'Edit';
        }
        return segment.charAt(0).toUpperCase() + segment.slice(1);
    }
  };

  return (
    <nav className="flex mb-4 bg-white p-4 rounded-lg shadow-sm" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        <li>
          <Link to="/" className="text-gray-400 hover:text-gray-500">
            <HomeIcon className="h-5 w-5" aria-hidden="true" />
            <span className="sr-only">Home</span>
          </Link>
        </li>
        {pathSegments.map((segment, index) => {
          const isLast = index === pathSegments.length - 1;
          const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
          const name = getBreadcrumbName(segment, index, pathSegments);
           
          // Skip rendering if name is null (for job ID)
          if (name === null) {
            return null;
          }
          
          return (
            <li key={path}>
              <div className="flex items-center">
                <ChevronRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                {isLast ? (
                  <span className="ml-2 text-sm font-medium text-gray-500">{name}</span>
                ) : (
                  <Link
                    to={path}
                    className="ml-2 text-sm font-medium text-[#009efb] hover:text-[#0089db]"
                  >
                    {name} 
                  </Link>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb; 